/*
 * @Author: Src
 * @Date: 2025-03-14 10:05:38
 * @LastEditTime: 2025-06-25 10:43:01
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/workbenchesRouter.ts
 * @Description: 头部注释配置模板
 */

import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import Workbenches from '@/views/workbenches/index.vue';

import MergePayment from '@/views/workbenches/page/MergePayment.vue';
import MinisterialPerformance from '@/views/workbenches/page/MinisterialPerformance.vue';
import OperationalPerformance from '@/views/workbenches/page/OperationalPerformance.vue';
import OperationalPerformanceLeader from '@/views/workbenches/page/OperationalPerformanceLeader.vue';
import PromoteCollision from '@/views/workbenches/page/PromoteCollision.vue';
import PromotionCompletion from '@/views/workbenches/page/PromotionCompletion.vue';
import PromotionOfBilling from '@/views/workbenches/page/PromotionOfBilling.vue';
import ReportForms from '@/views/workbenches/page/ReportForms.vue';
import ShouldEnrich from '@/views/workbenches/page/ShouldEnrich.vue';
import MonthlyPerformance from '@/views/workbenches/page/MonthlyPerformance.vue';
import GrowthData from '@/views/workbenches/page/GrowthData.vue';
import ShouldBeCharged from '@/views/workbenches/page/ShouldBeCharged.vue';
import CollisionLineStore from '@/views/workbenches/page/CollisionLineStore.vue';
import MergePaymentIng from '@/views/workbenches/page/MergePaymentIng.vue';
import StoreConsumed from '@/views/workbenches/page/StoreConsumed.vue';
import DepartmentPage from '@/views/workbenches/page/DepartmentPage.vue';
import PromotionCompletionRate from '@/views/workbenches/page/PromotionCompletionRate.vue';
import ConsumptionDetails from '@/views/workbenches/page/ConsumptionDetails.vue';
import AdvertiserFollowUp from '@/views/workbenches/page/AdvertiserFollowUp.vue';
import PromoteDailyData from '@/views/workbenches/page/PromoteDailyData.vue';
import ShopInspectionData from '@/views/workbenches/page/ShopInspectionData.vue';
import ParticipateInActivities from '@/views/workbenches/page/ParticipateInActivities.vue';
import TargetConsumptionManagement from '@/views/workbenches/page/TargetConsumptionManagement.vue';
import CPSInvestmentPromotion from '@/views/workbenches/page/CPSInvestmentPromotion.vue';
import WriteGMVAmount from '@/views/workbenches/page/WriteGMVAmount.vue';
import ListRechargeStores from '@/views/workbenches/page/ListRechargeStores.vue';
import GMVWriteOrders from '@/views/workbenches/page/GMVWriteOrders.vue';

import { AuthEnum } from '@/services/permission.service';

const workbenchesRouter: RouteConfig = {
  path: '/workbenches',
  component: Main,
  redirect: {
    name: 'workbenches.index',
  },
  meta: {
    title: '工作台',
  },
  children: [
    {
      name: 'workbenches.index',
      path: '/workbenches/index',
      component: Workbenches,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '运营工作台',
      },
    },
    {
      name: 'workbenches.mergePayment',
      path: '/workbenches/mergePayment',
      component: MergePayment,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '合并支付投放数据',
      },
    },
    {
      name: 'workbenches.ministerialPerformance',
      path: '/workbenches/ministerialPerformance',
      component: MinisterialPerformance,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '部长绩效',
      },
    },
    {
      name: 'workbenches.operationalPerformance',
      path: '/workbenches/operationalPerformance',
      component: OperationalPerformance,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '运营绩效',
      },
    },
    {
      name: 'workbenches.operationalPerformanceLeader',
      path: '/workbenches/operationalPerformanceLeader',
      component: OperationalPerformanceLeader,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '组长管理绩效',
      },
    },
    {
      name: 'workbenches.promoteCollision',
      path: '/workbenches/promoteCollision',
      component: PromoteCollision,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '推广通撞线数据',
      },
    },
    {
      name: 'workbenches.promotionCompletion',
      path: '/workbenches/promotionCompletion',
      component: PromotionCompletion,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '推广通充值完成率',
      },
    },
    {
      name: 'workbenches.promotionOfBilling',
      path: '/workbenches/promotionOfBilling',
      component: PromotionOfBilling,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '推广通开单数据',
      },
    },
    {
      name: 'workbenches.reportForms',
      path: '/workbenches/reportForms',
      component: ReportForms,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '部长推广通人效',
      },
    },
    {
      name: 'workbenches.shouldEnrich',
      path: '/workbenches/shouldEnrich',
      component: ShouldEnrich,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '应充实充数据',
      },
    },
    {
      name: 'workbenches.monthlyPerformance',
      path: '/workbenches/monthlyPerformance',
      component: MonthlyPerformance,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '月度业绩统计',
      },
    },
    {
      name: 'workbenches.growthData',
      path: '/workbenches/growthData',
      component: GrowthData,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '在投门店增长数据',
      },
    },
    {
      name: 'workbenches.ShouldBeCharged',
      path: '/workbenches/ShouldBeCharged',
      component: ShouldBeCharged,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '应充商家',
      },
    },
    {
      name: 'workbenches.CollisionLineStore',
      path: '/workbenches/CollisionLineStore',
      component: CollisionLineStore,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '撞线门店',
      },
    },
    {
      name: 'workbenches.MergePaymentIng',
      path: '/workbenches/MergePaymentIng',
      component: MergePaymentIng,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '合并支付待投放',
      },
    },
    {
      name: 'workbenches.StoreConsumed',
      path: '/workbenches/StoreConsumed',
      component: StoreConsumed,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '待消耗门店',
      },
    },
    {
      name: 'workbenches.DepartmentPage',
      path: '/workbenches/monthlyPerformance/DepartmentPage',
      component: DepartmentPage,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '月度部门详情',
      },
    },
    {
      name: 'workbenches.PromotionCompletionRate',
      path: '/workbenches/PromotionCompletionRate',
      component: PromotionCompletionRate,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '推广完消耗成率',
      },
    },
    {
      name: 'workbenches.ConsumptionDetails',
      path: '/workbenches/ConsumptionDetails',
      component: ConsumptionDetails,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '推广通消耗列表',
      },
    },
    {
      name: 'workbenches.AdvertiserFollowUp',
      path: '/workbenches/AdvertiserFollowUp',
      component: AdvertiserFollowUp,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '广告主跟进数据',
      },
    },
    {
      name: 'workbenches.PromoteDailyData',
      path: '/workbenches/PromoteDailyData',
      component: PromoteDailyData,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '推广通日常数据',
      },
    },
    {
      name: 'workbenches.ShopInspectionData',
      path: '/workbenches/ShopInspectionData',
      component: ShopInspectionData,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '巡店数据',
      },
    },
    {
      name: 'workbenches.ParticipateInActivities',
      path: '/workbenches/ParticipateInActivities',
      component: ParticipateInActivities,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '洗车节活动数据',
      },
    },
    {
      name: 'workbenches.TargetConsumptionManagement',
      path: '/workbenches/TargetConsumptionManagement',
      component: TargetConsumptionManagement,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '目标消耗额管理',
      },
    },
    {
      name: 'workbenches.CPSInvestmentPromotion',
      path: '/workbenches/CPSInvestmentPromotion',
      component: CPSInvestmentPromotion,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: 'CPS标品招商数据',
      },
    },
    {
      name: 'workbenches.WriteGMVAmount',
      path: '/workbenches/WriteGMVAmount',
      component: WriteGMVAmount,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '核销GMV金额数据',
      },
    },
    {
      name: 'workbenches.ListRechargeStores',
      path: '/workbenches/ListRechargeStores',
      component: ListRechargeStores,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: '推广通充值门店列表',
      },
    },
    {
      name: 'workbenches.GMVWriteOrders',
      path: '/workbenches/GMVWriteOrders/:id',
      component: GMVWriteOrders,
      props: {
        auth: [AuthEnum.运营工作台],
      },
      meta: {
        title: 'GMV核销订单列表',
      },
    },
  ],
};

export default workbenchesRouter;
